if (!customElements.get('pdp-simple-rating')) {
  customElements.define('pdp-simple-rating', class extends HTMLElement {
    connectedCallback() {
      this.badgeStates ||= new WeakMap();
      this.refresh = () => {
        const badge = this.querySelector('.jdgm-prev-badge') || this.querySelector('.jdgm-preview-badge');
        const label = badge?.querySelector('.jdgm-prev-badge__text, .jdgm-preview-badge__text');
        if (!badge || !label) return;
        const currentText = label.textContent.trim();
        const state = this.badgeStates.get(badge) || { sample: false, lastOutput: null };
        if (/sample reviews?/i.test(currentText)) state.sample = true;
        else if (state.sample && state.lastOutput !== null && currentText !== state.lastOutput) state.sample = false;
        const rawCount = badge.getAttribute('data-number-of-reviews') ?? this.querySelector('[data-number-of-reviews]')?.getAttribute('data-number-of-reviews');
        let count;
        if (state.sample) count = 0;
        else if (rawCount !== null && rawCount !== undefined && rawCount.trim() !== '') count = Number(rawCount.replace(/,/g, ''));
        else {
          const match = currentText.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          if (match) count = Number(match[1].replace(/,/g, ''));
          else if (/^(no reviews\b|write a review$)/i.test(currentText)) count = 0;
          else return;
        }
        if (!Number.isInteger(count) || count < 0) return;
        this.currentCount = count;
        const output = count === 0 ? 'Write a Review' : `${count.toLocaleString('en-US')} ${count === 1 ? 'review' : 'reviews'}`;
        state.lastOutput = output;
        this.badgeStates.set(badge, state);
        if (label.textContent !== output) label.textContent = output;
        if (!label.hasAttribute('tabindex')) label.setAttribute('tabindex', '0');
        if (!label.hasAttribute('role')) label.setAttribute('role', 'link');
        if (state.sample) {
          badge.querySelectorAll('.jdgm-star').forEach(star => {
            if (star.classList.contains('jdgm--on')) star.classList.remove('jdgm--on');
            if (star.classList.contains('jdgm--half')) star.classList.remove('jdgm--half');
            if (!star.classList.contains('jdgm--off')) star.classList.add('jdgm--off');
          });
          const stars = badge.querySelector('.jdgm-prev-badge__stars, .jdgm-preview-badge__stars');
          if (stars && stars.getAttribute('aria-label') !== 'No published reviews yet') stars.setAttribute('aria-label', 'No published reviews yet');
        }
      };
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-number-of-reviews', 'data-average-rating', 'data-score'] });
      this.onLabelClick = event => {
        if (this.currentCount !== 0 || !event.target.closest('.jdgm-prev-badge__text, .jdgm-preview-badge__text')) return;
        const widget = document.querySelector('.jdgm-review-widget');
        const writeButton = widget?.querySelector('.jdgm-write-rev-link');
        if (!writeButton) return;
        const form = widget.querySelector('.jdgm-form-wrapper');
        if (!form || getComputedStyle(form).display === 'none') writeButton.click();
        widget.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      };
      this.onLabelKeydown = event => {
        const label = event.target.closest('.jdgm-prev-badge__text, .jdgm-preview-badge__text');
        if (event.key === 'Enter' && label) { event.preventDefault(); label.click(); }
      };
      this.addEventListener('click', this.onLabelClick);
      this.addEventListener('keydown', this.onLabelKeydown);
      this.refresh();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onLabelClick);
      this.removeEventListener('keydown', this.onLabelKeydown);
    }
  });
}
